module.exports = __webpack_public_path__ + "static/media/check.f569e173.svg";